import React from 'react';

import _ from 'lodash';
import { Link, withRouter } from 'react-router-dom';
import { MenuItem, useTheme } from '@material-ui/core';

import { routes } from 'routes/Dashboard';
import { hasAnyRole } from 'utils/credentials';
import { useAuth } from 'hooks';

import logo from 'static/vr-logo192.png';
import styles from './Menubar.module.scss';

const Menubar = ({ location }) => {
  const auth = useAuth();
  const { palette } = useTheme();

  const roles = _.get(auth, 'currentGroup.myRoles', []);

  return (
    <div className={styles.menubar}>
      <img alt="circle_logo" className={styles.logo} src={logo} />

      {roles
        ? routes.map(({ path, icon: Icon, title, allow, disabled }) => {
            const selected =
              location.pathname === `/dashboard/${path}` ||
              location.pathname.startsWith(`/dashboard/${path}/`);

            return !disabled && hasAnyRole(allow, roles) ? (
              <Link to={`/dashboard/${path}`} key={path}>
                <MenuItem
                  className={styles.menuItem}
                  style={selected ? { backgroundColor: palette.primary.main } : null}
                  selected={selected}
                  title={title}
                >
                  <Icon
                    className={styles.icon}
                    style={selected ? { color: palette.common.white } : null}
                  />
                </MenuItem>
              </Link>
            ) : null;
          })
        : null}
    </div>
  );
};

export default withRouter(Menubar);
